import { render, staticRenderFns } from "./GroupMemberCard.vue?vue&type=template&id=d83a6f76"
import script from "./GroupMemberCard.vue?vue&type=script&lang=js"
export * from "./GroupMemberCard.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberCard.vue?vue&type=style&index=0&id=d83a6f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports